import {
  PaymentController,
  AdminController,
  CommonController,
  CompanyController,
  FairController,
  MembershipController,
  VisitorController,
  MessageController,
  PaymentsInicisController,
  BmsController,
  WebserviceController,
} from "./controllers"
import { BidNoticeController } from "./controllers/bidNotice"
import { fetchForm } from "./fetchapi"

export * from "./models/requestdto"
export * from "./models/responsedto"
export * from "./models/enum"

export class FmsApi {
  public admin = new AdminController(this)
  public common = new CommonController(this)
  public company = new CompanyController(this)
  public membership = new MembershipController(this)
  public visitor = new VisitorController(this)
  public fair = new FairController(this)
  public payment = new PaymentController(this)
  public message = new MessageController(this)
  public paymentInicis = new PaymentsInicisController(this)
  public bms = new BmsController(this)
  public bidNotice = new BidNoticeController(this)
  public webservice = new WebserviceController(this)

  private apiUrl: string

  constructor(apiUrl: string) {
    this.apiUrl = apiUrl
  }

  public async callApi(path: string, data?: any): Promise<Response> {
    let result = await fetchForm(`${this.apiUrl}${path}`, "POST", data)

    if (import.meta.env.VITE_MODE == "development") {
      let jsonResult = await result.clone().json() // 응답을 클론

      console.group(path)
      console.log("DATA", data)
      console.log("RESULT", jsonResult)
      console.groupEnd()
    }
    return result
  }

  public async callApiWithGet(path: string, data?: any): Promise<Response> {
    const queryString = new URLSearchParams(data).toString()
    const requestPath = `${path}/?${queryString}`

    const response = await fetch(`${this.apiUrl}${requestPath}`)

    if (import.meta.env.VITE_MODE == "development") {
      let jsonResult = await response.clone().json() // 응답을 클론

      console.group(path)
      console.log("RESULT", jsonResult)
      console.groupEnd()
    }

    return response
  }
}

export const fmsApi = new FmsApi(import.meta.env.VITE_FMS_API_URL)
